function stopPropagation(event) {
    event.stopPropagation();
}

export { stopPropagation };
